<template>
  <div class="issueList"  v-show="flowquaFlowList">
    <div class="addTitle">
      <span>流程清单</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <flowList ref="flowList" type="rvt" @closeAdd ="closeAdd" />
    </div>
  </div>
</template>

<script>
import flowList from "@/views/project/quaMange/flowList.vue"
import { mapState } from "vuex"
export default {
  components:{flowList},
  data(){
    return{
      flowquaFlowList:false,
    }
  },
  computed:{
    ...mapState({
      
    })
  },
  methods:{
    closeList(){
      this.flowquaFlowList = false
    },
    openList(data){
      this.flowquaFlowList = true
      this.$nextTick(()=>{
        this.$refs.flowList.init(data)
      })
    },
    closeArea(){
      this.flowquaFlowList = false
    },
    closeAdd(){
      this.flowquaFlowList = false
    },
  }
}
</script>

<style lang="scss" scoped>
.issueList{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 300px;
  z-index: 15;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  .addTitle{
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    width: 100%;
    height: calc(100% - 50px);
    padding: 10px 0px;
    overflow: hidden;
  }
}
</style>